module.exports = __webpack_public_path__ + "img/login_logo.6c4eb0c9.png";